<mat-toolbar>
  <div class="flex-div">
    <div class="spacer">
      <a routerLink="{{ (view$ | async) === 'cards' ? '/cards' : '/list' }}">
        <img
          alt="Logo"
          src="./assets/img/logo_no_claim.png"
          style="margin-left: 21px; height: auto"
          *ngIf="screenHeight < 900 || screenWidth < 900; else desktopIcon"
          class="mobile-icon"
        />
        <ng-template #desktopIcon>
          <img alt="Logo" src="./assets/img/logo.png" style="height: auto" />
        </ng-template>
      </a>
    </div>

    <div class="spacer center">
      <a routerLink="{{ (view$ | async) === 'cards' ? '/cards' : '/list' }}">
        <h4
          style="font-size: 12pt"
          *ngIf="screenHeight < 900 || screenWidth < 900; else desktopHeader"
        >
          Release Info Service
        </h4>
        <ng-template #desktopHeader>
          <h1 style="font-size: 16pt">Release Info Service</h1>
        </ng-template>
      </a>
    </div>

    <div class="spacer-left">
      @if ((permissionService.loggedIn$| async)) { @if
      ((permissionService.accessGranted$|async)) {
      <button
        [matMenuTriggerFor]="flagMenu"
        class="flag-button"
        mat-button
        *ngIf="!(screenHeight < 900 || screenWidth < 900)"
      >
        @if
        ((permissionService.accessRights$|async)?.userRight_RIS2_ACCESS_DEVELOPER_TEXTS$
        | async) {
        <span *ngIf="(language$ | async)?.id === 1">
          <mat-icon>developer_board</mat-icon></span
        >
        }
        <span *ngIf="(language$ | async)?.id === 2" class="fi fi-de"></span>
        <span *ngIf="(language$ | async)?.id === 3" class="fi fi-gb"></span>
      </button>
      <mat-menu #flagMenu="matMenu" xPosition="before">
        @for (lang of (languages$ | async); track lang.id) { @if (lang.id === 1)
        { @if
        ((permissionService.accessRights$|async)?.userRight_RIS2_ACCESS_DEVELOPER_TEXTS$
        | async) {
        <button (click)="setLanguage(lang)" mat-menu-item>
          <span
            *ngIf="lang.id === 1"
            style="display: flex; align-items: center"
          >
            <mat-icon>developer_board</mat-icon>
            <p style="margin-left: -6px">Developer</p>
          </span>
        </button>
        } } @else {
        <button (click)="setLanguage(lang)" mat-menu-item>
          <span *ngIf="lang.id === 2" class="fi fi-de"> </span>
          <span *ngIf="lang.id === 3" class="fi fi-gb"> </span>
          &nbsp; {{ lang.name }}
        </button>
        } }
      </mat-menu>
      }

      <button [matMenuTriggerFor]="accMenu" class="button-icon" mat-icon-button>
        <mat-icon>perm_identity</mat-icon>
      </button>
      <mat-menu #accMenu="matMenu" xPosition="before">
        <button class="menu-button" disabled mat-menu-item>
          {{
            (permissionService.loggedIn$ | async)
              ? (permissionService.user$ | async)?.mail
              : "not logged in"
          }}
        </button>
        @if
        (((permissionService.accessRights$|async)?.userRight_RIS2_MANAGEMENT_ENV_ACCESS$|async))
        {
        <button class="menu-button" mat-menu-item routerLink="/settings/user">
          <mat-icon>supervisor_account</mat-icon>
          User Settings
        </button>
        }
        <button
          class="menu-button"
          style="color: #f44336; font-weight: bold"
          mat-menu-item
          (click)="logout()"
          *ngIf="permissionService.loggedIn$ | async"
        >
          <mat-icon color="warn">power_settings_new</mat-icon>
          Logout
        </button>
        <button
          class="menu-button"
          mat-menu-item
          (click)="login()"
          *ngIf="!(permissionService.loggedIn$ | async)"
        >
          <mat-icon>account_circle</mat-icon>
          Login
        </button>
      </mat-menu>

      @if ((permissionService.accessGranted$| async)) {
      <button
        [matMenuTriggerFor]="entities"
        class="button-icon"
        mat-icon-button
      >
        <mat-icon>settings</mat-icon>
      </button>
      <mat-menu #entities="matMenu">
        @if
        (!((permissionService.accessRights$|async)?.userRight_RIS2_RESTORE_PRODUCT$|async)
        &&
        !((permissionService.accessRights$|async)?.userRight_RIS2_ENTITY_OVERVIEW$|async)
        &&
        !((permissionService.accessRights$|async)?.userRight_RIS2_APP_VERSION_OVERVIEW$|async))
        {
        <a>
          <button disabled mat-menu-item>No rights for any setting</button>
        </a>
        } @if
        ((permissionService.accessRights$|async)?.userRight_RIS2_RESTORE_PRODUCT$|async)
        {
        <a routerLink="settings/restore">
          <button mat-menu-item>
            <mat-icon>restore</mat-icon>
            Restore Data
          </button>
        </a>
        } @if
        ((permissionService.accessRights$|async)?.userRight_RIS2_ENTITY_OVERVIEW$|async)
        {
        <a routerLink="settings/entities">
          <button mat-menu-item>
            <mat-icon>link</mat-icon>
            Entity Overview
          </button>
        </a>
        } @if
        ((permissionService.accessRights$|async)?.userRight_RIS2_ACCESS_LOGS$|async)
        {
        <a routerLink="settings/logs">
          <button mat-menu-item>
            <mat-icon
              ><span class="material-symbols-outlined"
                >clear_all</span
              ></mat-icon
            >
            Logs
          </button>
        </a>
        }
        <!-- TODO: Recht anlegen -->
        <!-- @if ((permissionService.accessRights$|async)?.userRight_RIS2_ACCESS_LOGS$|async) { -->
        <a routerLink="settings/tags">
          <button mat-menu-item>
            <mat-icon
              ><span class="material-symbols-outlined"
                >bookmarks</span
              ></mat-icon
            >
            Tags
          </button>
        </a>
        <!-- } -->
        @if
        ((permissionService.accessRights$|async)?.userRight_RIS2_ACCESS_STATISTICS$|async)
        {
        <a routerLink="settings/statistics">
          <button mat-menu-item>
            <mat-icon
              ><span class="material-symbols-outlined"
                >query_stats</span
              ></mat-icon
            >
            Statistics
          </button>
        </a>
        } @if
        ((permissionService.accessRights$|async)?.userRight_RIS2_ACCESS_ERRORS$|async)
        {
        <a routerLink="settings/error">
          <button mat-menu-item>
            <mat-icon>
              <span class="material-symbols-outlined">warning</span>
            </mat-icon>
            Trigger Sentry Errors
          </button>
        </a>
        } @if
        ((permissionService.accessRights$|async)?.userRight_RIS2_APP_VERSION_OVERVIEW$|async)
        {
        <a routerLink="settings/info">
          <button mat-menu-item>
            <mat-icon>
              <span class="material-symbols-outlined">info</span>
            </mat-icon>
            Version Information
          </button>
        </a>
        }
      </mat-menu>

      @if (router.url.includes('list')) {
      <a routerLink="/cards">
        <button class="button-icon" mat-icon-button>
          <mat-icon>view_module</mat-icon>
        </button>
      </a>
      } @else {
      <a routerLink="/list">
        <button class="button-icon" mat-icon-button>
          <mat-icon>list</mat-icon>
        </button>
      </a>
      } } }
    </div>
  </div>
</mat-toolbar>
